
import { IYoelloTheme } from "../../yoello-lib/modules/themes/IYoelloTheme";
import { CSSProperties } from "@material-ui/core/styles/withStyles";
import { createStyles, makeStyles } from '@material-ui/core/styles';
function setItemFontStyles(fontFamily: string,
  fontStyle: string,
  fontWeight: any,
  fontSize: string,
  lineHeight: string,
  color: string): CSSProperties {
  return {
    fontFamily: fontFamily,
    fontStyle: fontStyle,
    fontWeight: fontWeight,
    fontSize: fontSize,
    lineHeight: lineHeight,
    color: color,
    margin: 0
  }
}
export const useStyles = makeStyles((theme: IYoelloTheme) =>
  createStyles({
    ModalContainer: {
      "& .MuiDialog-paperWidthMd": {
        width: "52.25rem!important",
        minWidth:"30rem!important"
      }
    },
    draggableMenuItems: {
      "&.draggable": {
        margin: "1rem 0",
      },

      "& .draggable-card": {
        display: "flex",
        alignItems: "stretch",
        flexDirection: "row",
        marginBottom: "15px",
        cursor: "move",

        "&:hover": {
          "& .draggable-item": {
            top: "-2px",
            left: "-2px",
            boxShadow: "2px 2px 5px rgba(0, 0, 0, 0.2)",
          },
        },
      },

      "& .draggable-handler": {
        width: "4.375rem",
        backgroundImage: 'url("/assets/images/icon-handler.svg")',
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        flexShrink: "0",
        display: "block",
        "@media only screen and (max-width: 600px)": {
          display: "none",
        },
      },

      "& .draggable-onDrag": {
        width: "4.375rem",
        backgroundImage: 'url("/assets/images/icon-dnd-touch.svg")',
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        flexShrink: 0,
      },
      "& .draggable-item": {
        width: "100%",
        cursor: "pointer",
        display: "grid !important",
        padding: "1.5625rem 2rem",
        overflow: "hidden",
        position: "relative",
        boxShadow: "1px 1px 3px rgb(0 0 0 / 20%)",
        transition: "background-color 0.3s",
        alignItems: "center",
        borderRadius: "0.625rem",
        justifyContent: "space-between",
        backgroundColor: "#ffffff",
        gridTemplateColumns: "34% 56% 10%",
        "@media only screen and (max-width: 1280px)": {
          display: "flex !important",
        }
      },
      "& .draggable-name_public": {
        fontFamily: "Open Sans",
        fontStyle: "normal",
        fontWeight: "600",
        fontSize: "1.0625rem",
        lineHeight: "1.4375rem",
        display: "flex",
        alignItems: "center",
        color: "#212121",
        paddingRight: "1rem",
        paddingTop: "unset"
      },
      "& .draggable-description": {
        fontFamily: "Open Sans!important",
        fontStyle: "normal!important",
        fontWeight: "normal!important",
        fontSize: "0.9375rem!important",
        lineHeight: "1.25rem!important",
        display: "flex!important",
        alignItems: "center!important",
        color: "#757575!important",
        paddingTop: "unset",
        paddingRight: "2rem"
      },
      "& .draggable-enabled": {
        "& span": {
          fontFamily: "Open Sans!important",
          fontStyle: "normal!important",
          fontWeight: "normal!important",
          fontSize: "0.875rem!important",
          lineHeight: "1.1875rem!important",
          display: "flex!important",
          alignItems: "center!important",
        }
      }
    },
    headers: {
      paddingLeft: "6.375rem",
      paddingRight: "unset!important",
      "& >div": {
        width: "33.7%!important",
        "& >span": {
          justifyContent: "unset!important"
        }
      }
    },
    TimingMenuContainer: {
      "& label": {
        ...setItemFontStyles("sofia-pro, 'Open Sans', Helvetica, Arial, sans-serif",
          "normal", 400, "1rem", "1rem", "#757575"),
      },
      "& >div": {
        display: "flex",
        marginTop: "0.625rem",
        "& >p": {
          ...setItemFontStyles("Open Sans",
            "normal", "normal", "0.8125rem", "1.125rem", "#737FA4"),
          marginLeft: "1.25rem",
          marginTop: ".2rem"
        }
      },
      "& main": {
        border: "1px solid #E8EAF4",
        boxSizing: "border-box",
        borderRadius: "14px",
        background: "#F3F4F9",
        marginTop: "1.25rem",
      }
    },
    InfoCard: {
      marginTop: "1.875rem",
      padding: "1.25rem 1.5625rem",
      background: "#F1F9FF",
      borderRadius: "0.75rem",
      maxWidth: "60rem",
      "& >header": {
        display: "flex",
        "& >p": {
          ...setItemFontStyles("Open Sans",
            "normal", 600, "0.9375rem", "1.25rem", "#212121"),
          paddingLeft: "0.625rem"
        }
      },
      "& >p": {
        ...setItemFontStyles("Open Sans",
          "normal", "normal", "0.9375rem", "1.625rem", "#616161"),
        margin: "1rem 0"
      }
    },
    WorkDays: {
      borderBottom: " 1px solid rgb(232, 234, 244)",
      display: "grid",
      gridTemplateColumns: "35% 65%",
      alignItems: "baseline",
      "& >div:last-child": {
        background: "#FFFFFF",
      }
    },
    TimingCheckboxWrapper: {
      display: "flex",
      alignItems: "center",
      padding: "6px 15px",
      justifyContent: "space-between",
      margin: "auto 0",
      "& .MuiTypography-body1": {
        width: "100%",
        ...setItemFontStyles("Open Sans",
          "normal", "normal", "0.9375rem", "1.25rem", "#8D98B7")
      },
      "& .MuiSvgIcon-root": {
        "& path": {
          fill: "#C1CAE1"
        }
      },
      "& .MuiCheckbox-colorPrimary.Mui-checked": {
        "& .MuiSvgIcon-root": {
          "& path": {
            fill: "unset!important"
          }
        }
      },
      "& >svg": {
        border: "1.3px solid #AAB6D3",
        boxSizing: "border-box",
        borderRadius: "50%",
        cursor: "pointer",
        width: "1.25rem",
        height: "1.25rem"
      }
    },
    TimeInputsWrapper: {
      display: "grid",
      padding: "15px 25px",
      gridTemplateColumns: "90% 10%",
      "& svg": {
        fill: "#C1CAE1",
        cursor: "pointer"
      }
    },
    TimeInputs: {
      display: "grid",
      gridTemplateColumns: "50% 50%",
      alignItems: "baseline",
      justifyItems: "center",
      "& input": {
        width: "6rem",
        border: "unset",
        outline: "unset",
        textAlign:"center",
        "&::-webkit-calendar-picker-indicator" :{
          background: "none!important",
          width:"0px!important",
          display:"none!important"
        },
        "&::placeholder": {
          ...setItemFontStyles("Open Sans",
            "normal", "normal", "0.875rem", "1.1875rem", "#C1CAE1")
        },
        "& ::-webkit-input-placeholder":{ 
          color: "red;"
        },
        "&:focus": {
          border: "unset",
        },
      },
      "& .datetime-reset-button":{
        display:"none!important"
      },
    },
    DisableEvents: {
      pointerEvents: "none",
      "& >div>input":{
        color:"rgba(0, 0, 0, 0.38)!important"
      }
    },
  }),
);